<template>
  <div>
    <div class="package-list">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="parcelItem in parcelTabs"
          :key="parcelItem.id"
          :label="parcelItem.label"
          :name="parcelItem.name"
        >
          <ParcelItem
            :tracks="formatTraces"
            :deliveryInfo="deliveryInformation"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import ParcelItem from './components/ParcelItem';
export default {
  name: 'LogisticsList',
  components: {
    ParcelItem,
  },
  data() {
    return {
      deliveryOrderNo: '', // deliveryOrderNo 运单号
      activeName: 0,
    };
  },
  computed: {
    ...mapState('logistics', ['formatTraces', 'deliveryInformation']),
    ...mapGetters('logistics', {
      parcelTabs: 'getParcelTabs',
    }),
  },
  created() {
    this.initData();
  },
  methods: {
    ...mapActions('logistics', ['getLogisticsList', 'getLogistics']),
    initData() {
      this.deliveryOrderNo = this.$route.params.id;
      this.fetchData();
    },
    fetchData() {
      const { deliveryOrderNo } = this;
      this.getLogisticsList({ deliveryOrderNo });
    },
    handleClick(item) {
      const { deliveryOrderNo } = this;
      const { expressOrderNo } = this.parcelTabs[item.index];
      this.getLogistics({
        deliveryOrderNo,
        expressOrderNo,
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-tabs--card > .el-tabs__header {
  margin-bottom: 0 !important;
  border-bottom: none;
  .el-tabs__nav {
    display: flex;

    .el-tabs__item {
      height: 100%;
      width: 90px;
      height: 30px;
      line-height: 32px;
      text-align: center;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      display: block;
      list-style: none;
      font-size: 14px;
      font-weight: 500;
      color: #333;
      position: static;
      font-family: PingFangSC-Medium, PingFang SC;
    }

    .is-active {
      color: #fff;
      background-color: #3d96e2;
    }
  }
}

/deep/ .el-tabs__content {
  border: solid 1px #e5e5e5;
  padding: 24px;
}
</style>
